import { getInsightsAnonymousUserTokenInternal } from "instantsearch.js/es/helpers";
import { checkIndexUiState } from "instantsearch.js/es/lib/utils";

class videoIframe {
    ytIframes: NodeListOf<HTMLElement>;


    constructor() {
        this.init();
    }

    init() {
        this.ytIframes = document.querySelectorAll('iframe[src*="youtube.com"]');
        let imgUrl = '';
        const self = this;
        

        this.ytIframes.forEach(frame => {
            const isInModal = frame.parentElement.classList.contains('modal-content');
            let ytFrame = frame;
            let ytKey;
            let ytPath = ytFrame.getAttribute('src').split(/\//);
            let tmp = ytPath[ytPath.length - 1].split('?');
            ytKey = tmp[0];
            let vidSrc;
            const ytLoader = document.createElement('div');
            let imgSrc;

            //get thumbnail from youtube, if no image, use SAIT default
            this.getImg(ytKey,(load)=>{
                imgSrc = load ? 'https://www.sait.ca/assets/app/sait/images/bg/bg-video-default.jpg' : `https://i.ytimg.com/vi/${ytKey}/maxresdefault.jpg`;
                self.createVideoWrapper(frame, imgSrc, ytLoader);
            });
            
            vidSrc = ytFrame.getAttribute('src');
            ytLoader.setAttribute('data-src', vidSrc);

            //play video in frame if not in popup
            if (!isInModal) {
                ytLoader.addEventListener('click', (e) => {
                    self.replaceWithVideo(vidSrc, ytLoader, ytFrame);
                });
            }

        })

    }

    createVideoWrapper(frame, imgSrc, wrapper) {
        const ytImg = document.createElement('div');
        const playBtn = document.createElement('div');
    
    
        //add classes, set wrapper height/width same as video, set background, add playbtn
        wrapper.setAttribute('class', 'yt-loader');
        ytImg.setAttribute('class', 'yt-cover');
        
        ytImg.style.backgroundImage = `url('${imgSrc}')`;
        //use svg play button
        playBtn.setAttribute('class', 'play-btn-wrap');
        playBtn.innerHTML = "<button class=\"play-btn\" aria-label=\"Play Video\"></div>";
        //wrapper.style.width = frameWidth + 'px';
        //wrapper.style.height = frameHeight + 'px';
        wrapper.appendChild(ytImg);
        wrapper.appendChild(playBtn);
        frame.replaceWith(wrapper);
    }

    getImg(id, callback){
        let srcImg = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
        var img = new Image();
        var isDefault = true;
        img.src = srcImg;
    
        img.onload = function(){
            //default thumbnail is 120px wide
            if(img.width > 120){
                isDefault = false;
            } 
            callback(isDefault)
         }
       
        return isDefault;
    }    

    replaceWithVideo(src, target, newVideo) {
        if (!src.includes('?rel=0&modestbranding=1&enablejsapi=1')) {
            newVideo.setAttribute('src', src + '?autoplay=1&rel=0&modestbranding=1&enablejsapi=1');
        } else {
            newVideo.setAttribute('src', src);
        }
        target.replaceWith(newVideo);
    }

    loadApi() {
        //load YouTube API script async
        const scriptTag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];
        scriptTag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    }

}

export default videoIframe;